import styles from './styles/FeaturesPanel.css'
import { Link } from 'react-router-dom'
import Header from '../typography/Header'
import P from 'components/typography/Paragraph'
import Button from '../forms/Button'
import Feature from '../navbar/Feature'
import Card from '../layout/Card'

const FeaturesPanel = () => {
  return (
    <div className={styles.container}>
      <div className={styles.layout}>
        <Header className={styles.header} level={3}>
          Never waste time looking for and evaluating research again
        </Header>
        <P className={styles.paragraph}>
          By seeing how research has been cited all in one place, researchers, students, and research evaluators can easily find relevant and well supported results.
        </P>
        <div className={styles.featureGrid}>
          <Card level={4} className={styles.featureCard}>
            <Feature
              imgTop
              className={styles.feature}
              to='/search'
              header='Search Citation Statements'
              img={`${CONFIG.assetsBaseURL}/images/icons/feature-search.svg`}
            >
              Surface interesting debate in topics of interest by directly searching our unique database of Citation Statements.
            </Feature>
          </Card>
          <Card level={4} className={styles.featureCard}>
            <Feature
              imgTop
              className={styles.feature}
              to='/create-dashboard'
              header='Create Dashboard'
              img={`${CONFIG.assetsBaseURL}/images/icons/feature-dashboards.svg`}
            >
              Evaluate groups of articles in a single place. <br />

              Get notified when a new supporting or contrasting citation is made to one of your articles.
            </Feature>
          </Card>
          <Card level={4} className={styles.featureCard}>
            <Feature
              imgTop
              className={styles.feature}
              to='/journals'
              header='Journals & Institution Metrics'
              img={`${CONFIG.assetsBaseURL}/images/icons/feature-journals.svg`}
            >
              Explore journal and institutional dashboards to find their publications, compare rankings, and see changes in their yearly scite Index
            </Feature>
          </Card>
          <Card level={4} className={styles.featureCard}>
            <Feature
              imgTop
              className={styles.feature}
              to='/visualizations/global-analysis-of-genome-transcriptome-9L4dJr?dois[0]=10.1038%2Fmsb.2012.40&dois[1]=10.7554%2Felife.05068&focusedElement=10.7554%2Felife.05068'
              header='Visualize Research'
              img={`${CONFIG.assetsBaseURL}/images/icons/feature-visualize.svg`}
            >
              Surf the citation web!
              Discover and evaluate how articles cite each other through interactive scite Visualizations
            </Feature>
          </Card>
          <Card level={4} className={styles.featuredCard}>
            <div className={styles.featured}>
              <img alt='featured image' src={`${CONFIG.assetsBaseURL}/images/icons/reference-check-feature-icon.svg`} />
              <P className={styles.featuredText}>
                <strong>Do you know if your references are retracted, or have other issues?</strong>
                <br />
                Reference Check gives you peace of mind that you are using high quality references and that you haven't missed any important details.
                <br />Upload a copy of your manuscript (docx or pdf) and get a report showing you whether any of your references have concerning editorial notices (like retractions or corrections), or are heavily contrasted by newer literature.
              </P>
              <P bold className={styles.tryit}>
                Try it now!
              </P>
              <div className={styles.btnGroup}>
                <Link to='/?referenceCheck'>
                  <Button className={styles.btn} color='blue' bold>
                    Upload Document
                  </Button>
                </Link>
                <Link to='/reference-check/683e0cbc-b322-4692-be6d-f5432b4a453c'>
                  <Button className={styles.btn} color='white' bold>
                    See Example Report
                  </Button>
                </Link>
              </div>
            </div>
            <Header className={styles.referenceCheckHeader} level={6}>
              Reference Check
            </Header>
            <P light>
              Upload a manuscript to see if any of your references have been retracted, heavily contrasted, find missing citations, or to see how others reference the same studies
            </P>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default FeaturesPanel
